import { createSlice } from "@reduxjs/toolkit";

export const SelectedCareersClientSlice = createSlice({
  name: "selectedCareersClient",
  initialState: {
    value: [],
  },
  reducers: {
    updateCareersClient: (state, action) => {
      state.value = action.payload;
    },
    removeCareersClient: (state) => {
      state.value = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateCareersClient, removeCareersClient } =
  SelectedCareersClientSlice.actions;

export const selectCareersClientValue = (state) =>
  state.selectedCareersClient.value;

export default SelectedCareersClientSlice.reducer;
